import styled from "styled-components";
import * as theme from "../../../../theme";
import closeIcon from "../../../../statics/img/icon-clear-dark.svg";
import warningIcon from "../../../../statics/img/icon-orange-warning.svg";

export const StyledIntegrationErrorBanner = styled.div`
  height: auto;
  background-color: ${theme.palette.paleOrange};
  margin: 0px auto;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;

  .close_icon {
    height: 16px;
    width: 16px;
    background: url(${closeIcon});
    cursor: pointer;
    background-size: contain;
  }

  .banner-content {
    display: flex;
    align-items: center;
    gap: 8px;

    .img_icon {
      height: 24px;
      width: 24px;
      background: url(${warningIcon});
      margin-right: 10px;
    }

    .message {
      color: ${theme.palette.gunmetal};
      line-height: 24px;
      font-weight: ${theme.font.mainFontWeight};

      span {
        text-decoration: underline;
        color: ${theme.palette.gunmetal};
        cursor: pointer;
      }
    }
  }
`;
